'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _index = require('../../../common/links/index');

var _index2 = _interopRequireDefault(_index);

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

var _LinkContainer = require('./LinkContainer');

var _LinkContainer2 = _interopRequireDefault(_LinkContainer);

var _toolbarConstants = require('../../workspace/toolbar/toolbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _index2.default)({
        containerComponent: _LinkContainer2.default,
        presentationalComponent: _Link2.default,
        tools: [_toolbarConstants.TOOLS.RICH_TEXT, _toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.ATTACHMENT, _extends({}, _toolbarConstants.TOOLS.CAPTION, { name: 'Description' })]
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/index.js
// module id = 2003
// module chunks = 0